import React, {useState} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
// import fooerP from '../img/Article → Footer.png';
import Comp1 from '../img/C1.png'
import Comp2 from '../img/C2.png'
import Comp3 from '../img/C3.png'
import Comp4 from '../img/C4.png'
import "../css/CompC.css"
import Text from '../../../common/Text.js';

import Header from '../../../common/Header_White_Base';

function CompCulture() {
    const [Display, setDisplay] = useState('none');
    const [remainingHeight, setRemainingHeight] = useState(0);
    const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);

    };
    const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
    };


     return (
        <div>
         <div className='contentWrapper'>
                <div style={{marginTop:'50px',display:'flex'}}>
                <Text variant="titlename"  className="TitleC">
                    복리후생
                </Text>
                </div>
                    <div class="ContS2">
                        <Text variant="px32B" >임직원의 행복하고 안정적인 삶을 적극적으로 지원합니다.</Text>
                        <div style={{display:"flex", flexDirection:"column",  margin:'52px 0px 100px 0px'}}>

                            <div style={{display:"flex", flexDirection:'row',marginBottom:'20px',marginLeft:'23px'}}>
                                <div style={{display:"flex",marginRight:'40px'}}>
                                    <img src={Comp1}/>
                                 </div>
                                <div style={{display:"flex", flexDirection:"column",justifyContent:'center'}}>
                                    <p className='ContentsText'>사내문화</p>
                                    <Text variant="px24" style={{display:"flex"}} >유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</Text>
                                </div>
                            </div>

                            <div style={{display:"flex", flexDirection:'row',marginBottom:'20px',marginLeft:'23px'}}>
                                <div style={{display:"flex",marginRight:'40px'}}>
                                    <img src={Comp2}/>
                                 </div>
                                <div style={{display:"flex", flexDirection:"column",justifyContent:'center'}}>
                                    <p className='ContentsText'>의료 지원</p>
                                    <Text variant="px24" style={{display:"flex"}} >의료비 지원, 종합검진비 지원, 단체상해보험, 모성보호실 운영</Text>
                                </div>
                            </div>

                            <div style={{display:"flex", flexDirection:'row',marginBottom:'20px',marginLeft:'23px'}}>
                                <div style={{display:"flex",marginRight:'40px'}}>
                                    <img src={Comp3}/>
                                 </div>
                                <div style={{display:"flex", flexDirection:"column",justifyContent:'center'}}>
                                    <p className='ContentsText'>생활 지원</p>
                                    <Text variant="px24" style={{display:"flex"}} >경조사 지원, 학자금 지원, 주택대부금 지원</Text>
                                </div>
                            </div>

                            <div style={{display:"flex", flexDirection:'row',marginBottom:'20px',marginLeft:'23px'}}>
                                <div style={{display:"flex",marginRight:'40px'}}>
                                    <img src={Comp4}/>
                                 </div>
                                <div style={{display:"flex", flexDirection:"column",justifyContent:'center'}}>
                                    <p className='ContentsText'>자기 계발 지원</p>
                                    <Text variant="px24" style={{display:"flex"}} >어학 시험 비용 지원, 품질 검사원 국제 자격증 갱신비 지원</Text>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
          
         </div>
     );
 }
 
 export default CompCulture;